import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/united-kingdom.geojson";

const REGIONS = [
    { code: "Aberdeen", name: "Aberdeen" },
    { code: "Aberdeenshire", name: "Aberdeenshire" },
    { code: "Anglesey", name: "Anglesey" },
    { code: "Angus", name: "Angus" },
    { code: "Antrim", name: "Antrim" },
    { code: "Ards", name: "Ards" },
    { code: "Argyll and Bute", name: "Argyll and Bute" },
    { code: "Armagh", name: "Armagh" },
    { code: "Ballymena", name: "Ballymena" },
    { code: "Ballymoney", name: "Ballymoney" },
    { code: "Banbridge", name: "Banbridge" },
    { code: "Barking and Dagenham", name: "Barking and Dagenham" },
    { code: "Bath and North East Somerset", name: "Bath and North East Somerset" },
    { code: "Bedfordshire", name: "Bedfordshire" },
    { code: "Belfast", name: "Belfast" },
    { code: "Berkshire", name: "Berkshire" },
    { code: "Bexley", name: "Bexley" },
    { code: "Blackburn with Darwen", name: "Blackburn with Darwen" },
    { code: "Blaenau Gwent", name: "Blaenau Gwent" },
    { code: "Bournemouth", name: "Bournemouth" },
    { code: "Brent", name: "Brent" },
    { code: "Bridgend", name: "Bridgend" },
    { code: "Brighton and Hove", name: "Brighton and Hove" },
    { code: "Bristol", name: "Bristol" },
    { code: "Bromley", name: "Bromley" },
    { code: "Buckinghamshire", name: "Buckinghamshire" },
    { code: "Caerphilly", name: "Caerphilly" },
    { code: "Cambridgeshire", name: "Cambridgeshire" },
    { code: "Camden", name: "Camden" },
    { code: "Cardiff", name: "Cardiff" },
    { code: "Carmarthenshire", name: "Carmarthenshire" },
    { code: "Carrickfergus", name: "Carrickfergus" },
    { code: "Castlereagh", name: "Castlereagh" },
    { code: "Ceredigion", name: "Ceredigion" },
    { code: "Cheshire", name: "Cheshire" },
    { code: "Clackmannanshire", name: "Clackmannanshire" },
    { code: "Coleraine", name: "Coleraine" },
    { code: "Conwy", name: "Conwy" },
    { code: "Cookstown", name: "Cookstown" },
    { code: "Cornwall", name: "Cornwall" },
    { code: "Craigavon", name: "Craigavon" },
    { code: "Croydon", name: "Croydon" },
    { code: "Cumbria", name: "Cumbria" },
    { code: "Darlington", name: "Darlington" },
    { code: "Denbighshire", name: "Denbighshire" },
    { code: "Derby", name: "Derby" },
    { code: "Derbyshire", name: "Derbyshire" },
    { code: "Derry", name: "Derry" },
    { code: "Devon", name: "Devon" },
    { code: "Dorset", name: "Dorset" },
    { code: "Down", name: "Down" },
    { code: "Dumfries and Galloway", name: "Dumfries and Galloway" },
    { code: "Dundee", name: "Dundee" },
    { code: "Dungannon", name: "Dungannon" },
    { code: "Durham", name: "Durham" },
    { code: "Ealing", name: "Ealing" },
    { code: "East Ayrshire", name: "East Ayrshire" },
    { code: "East Dunbartonshire", name: "East Dunbartonshire" },
    { code: "East Lothian", name: "East Lothian" },
    { code: "East Renfrewshire", name: "East Renfrewshire" },
    { code: "East Riding of Yorkshire", name: "East Riding of Yorkshire" },
    { code: "East Sussex", name: "East Sussex" },
    { code: "Edinburgh", name: "Edinburgh" },
    { code: "Eilean Siar", name: "Eilean Siar" },
    { code: "Enfield", name: "Enfield" },
    { code: "Essex", name: "Essex" },
    { code: "Falkirk", name: "Falkirk" },
    { code: "Fermanagh", name: "Fermanagh" },
    { code: "Fife", name: "Fife" },
    { code: "Flintshire", name: "Flintshire" },
    { code: "Glasgow", name: "Glasgow" },
    { code: "Gloucestershire", name: "Gloucestershire" },
    { code: "Greenwich", name: "Greenwich" },
    { code: "Gwynedd", name: "Gwynedd" },
    { code: "Hackney", name: "Hackney" },
    { code: "Halton", name: "Halton" },
    { code: "Hammersmith and Fulham", name: "Hammersmith and Fulham" },
    { code: "Hampshire", name: "Hampshire" },
    { code: "Haringey", name: "Haringey" },
    { code: "Harrow", name: "Harrow" },
    { code: "Hartlepool", name: "Hartlepool" },
    { code: "Havering", name: "Havering" },
    { code: "Herefordshire", name: "Herefordshire" },
    { code: "Hertfordshire", name: "Hertfordshire" },
    { code: "Highland", name: "Highland" },
    { code: "Hillingdon", name: "Hillingdon" },
    { code: "Hounslow", name: "Hounslow" },
    { code: "Inverclyde", name: "Inverclyde" },
    { code: "Isle of Wight", name: "Isle of Wight" },
    { code: "Islington", name: "Islington" },
    { code: "Kensington and Chelsea", name: "Kensington and Chelsea" },
    { code: "Kent", name: "Kent" },
    { code: "Kingston upon Hull", name: "Kingston upon Hull" },
    { code: "Kingston upon Thames", name: "Kingston upon Thames" },
    { code: "Lambeth", name: "Lambeth" },
    { code: "Lancashire", name: "Lancashire" },
    { code: "Larne", name: "Larne" },
    { code: "Leicester", name: "Leicester" },
    { code: "Leicestershire", name: "Leicestershire" },
    { code: "Lewisham", name: "Lewisham" },
    { code: "Limavady", name: "Limavady" },
    { code: "Lincolnshire", name: "Lincolnshire" },
    { code: "Lisburn", name: "Lisburn" },
    { code: "London", name: "London" },
    { code: "Luton", name: "Luton" },
    { code: "Magherafelt", name: "Magherafelt" },
    { code: "Manchester", name: "Manchester" },
    { code: "Medway", name: "Medway" },
    { code: "Merseyside", name: "Merseyside" },
    { code: "Merthyr Tydfil", name: "Merthyr Tydfil" },
    { code: "Merton", name: "Merton" },
    { code: "Middlesbrough", name: "Middlesbrough" },
    { code: "Midlothian", name: "Midlothian" },
    { code: "Milton Keynes", name: "Milton Keynes" },
    { code: "Monmouthshire", name: "Monmouthshire" },
    { code: "Moray", name: "Moray" },
    { code: "Moyle", name: "Moyle" },
    { code: "Neath Port Talbot", name: "Neath Port Talbot" },
    { code: "Newham", name: "Newham" },
    { code: "Newport", name: "Newport" },
    { code: "Newry and Mourne", name: "Newry and Mourne" },
    { code: "Newtownabbey", name: "Newtownabbey" },
    { code: "Norfolk", name: "Norfolk" },
    { code: "North Ayrshire", name: "North Ayrshire" },
    { code: "North Down", name: "North Down" },
    { code: "North East Lincolnshire", name: "North East Lincolnshire" },
    { code: "North Lanarkshire", name: "North Lanarkshire" },
    { code: "North Lincolnshire", name: "North Lincolnshire" },
    { code: "North Somerset", name: "North Somerset" },
    { code: "North Yorkshire", name: "North Yorkshire" },
    { code: "Northamptonshire", name: "Northamptonshire" },
    { code: "Northumberland", name: "Northumberland" },
    { code: "Nottingham", name: "Nottingham" },
    { code: "Nottinghamshire", name: "Nottinghamshire" },
    { code: "Omagh", name: "Omagh" },
    { code: "Orkney Islands", name: "Orkney Islands" },
    { code: "Oxfordshire", name: "Oxfordshire" },
    { code: "Pembrokeshire", name: "Pembrokeshire" },
    { code: "Perthshire and Kinross", name: "Perthshire and Kinross" },
    { code: "Peterborough", name: "Peterborough" },
    { code: "Plymouth", name: "Plymouth" },
    { code: "Poole", name: "Poole" },
    { code: "Portsmouth", name: "Portsmouth" },
    { code: "Powys", name: "Powys" },
    { code: "Redbridge", name: "Redbridge" },
    { code: "Redcar and Cleveland", name: "Redcar and Cleveland" },
    { code: "Renfrewshire", name: "Renfrewshire" },
    { code: "Rhondda, Cynon, Taff", name: "Rhondda, Cynon, Taff" },
    { code: "Richmond upon Thames", name: "Richmond upon Thames" },
    { code: "Rutland", name: "Rutland" },
    { code: "Scottish Borders", name: "Scottish Borders" },
    { code: "Shetland Islands", name: "Shetland Islands" },
    { code: "Shropshire", name: "Shropshire" },
    { code: "Somerset", name: "Somerset" },
    { code: "South Ayrshire", name: "South Ayrshire" },
    { code: "South Gloucestershire", name: "South Gloucestershire" },
    { code: "South Lanarkshire", name: "South Lanarkshire" },
    { code: "South Yorkshire", name: "South Yorkshire" },
    { code: "Southampton", name: "Southampton" },
    { code: "Southend-on-Sea", name: "Southend-on-Sea" },
    { code: "Southwark", name: "Southwark" },
    { code: "Staffordshire", name: "Staffordshire" },
    { code: "Stirling", name: "Stirling" },
    { code: "Stockton-on-Tees", name: "Stockton-on-Tees" },
    { code: "Stoke-on-Trent", name: "Stoke-on-Trent" },
    { code: "Strabane", name: "Strabane" },
    { code: "Suffolk", name: "Suffolk" },
    { code: "Surrey", name: "Surrey" },
    { code: "Sutton", name: "Sutton" },
    { code: "Swansea", name: "Swansea" },
    { code: "Swindon", name: "Swindon" },
    { code: "Telford and Wrekin", name: "Telford and Wrekin" },
    { code: "Thurrock", name: "Thurrock" },
    { code: "Torbay", name: "Torbay" },
    { code: "Torfaen", name: "Torfaen" },
    { code: "Tower Hamlets", name: "Tower Hamlets" },
    { code: "Tyne and Wear", name: "Tyne and Wear" },
    { code: "Vale of Glamorgan", name: "Vale of Glamorgan" },
    { code: "Waltham Forest", name: "Waltham Forest" },
    { code: "Wandsworth", name: "Wandsworth" },
    { code: "Warrington", name: "Warrington" },
    { code: "Warwickshire", name: "Warwickshire" },
    { code: "West Dunbartonshire", name: "West Dunbartonshire" },
    { code: "West Lothian", name: "West Lothian" },
    { code: "West Midlands", name: "West Midlands" },
    { code: "West Sussex", name: "West Sussex" },
    { code: "West Yorkshire", name: "West Yorkshire" },
    { code: "Westminster", name: "Westminster" },
    { code: "Wiltshire", name: "Wiltshire" },
    { code: "Worcestershire", name: "Worcestershire" },
    { code: "Wrexham", name: "Wrexham" },
    { code: "York", name: "York" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const UKCountiesMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 2200, center: [-3, 55] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="uk-counties"
            analyticsLocationType="uk_counties"
            trackingLabel="UK Counties Map"
            storageKey="uk-counties_map"
            title="🇬🇧 UK Counties Travel Map"
            subtitle="Click on UK counties and unitary authorities you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Counties"
            unitLabel="counties and unitary authorities"
            captionUnit="UK counties and unitary authorities"
            share={{
                region: 'UK',
                fileName: 'visited-uk-counties-map.png',
                trackId: 'uk-counties'
            }}
            renderMap={renderMap}
        />
    );
};

export default UKCountiesMapSection;
